<template>
    <div v-if="!!showFigures">
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Indicadores Por Cliente"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <app-figure title="Total PQR's">
                    {{ total }}
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="Completas">
                    {{ completed }}
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="Efectividad">
                    {{ performance | decimal(0) }}%
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="T. Prom. Resolución">
                    {{ resolutionTime | decimal(2) }} días
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="T. Prom. R. Cliente">
                    {{ completionTime | decimal(2) }} días
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="Prom. Mensual">
                    {{ monthAverage | decimal(0) }}
                </app-figure>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import reportingRepository from '../../../../../../repositories/reporting.repository';
import Figure from '../../../../../UI/Reports/Figure';
export default {
    components: {
        appFigure: Figure
    },
    props: ['selectedClient', 'year', 'month'],
    data: () => ({
        total: 0,
        completed: 0,
        performance: 0,
        resolutionTime: 0,
        completionTime: 0,
        monthAverage: 0,
        showFigures: false
    }),
    methods: {
        async loadClientFigures() {
            try {
                const rr = {...reportingRepository};
                const {data} = await rr.getPqrClientFigures(this.selectedClient.id, this.year, this.month);
                this.showFigures = true;
                this.total = data.total;
                this.completed = data.completed;
                this.performance = data.completed / data.total * 100;
                this.resolutionTime = data.resolutionTime;
                this.completionTime = data.completionTime;
                this.monthAverage = data.monthAverage.average;
            } catch(err) {
                toastr.error(`Ocurrió un error al cagar los indicadores del cliente [${err.message}]`);
            }
        }
    },
    created() {
        this.$bus.$on('pqr-client-figures.load', this.loadClientFigures);
    },
    beforeDestroy() {
        this.$bus.$off('pqr-client-figures.load');
    }
}
</script>